import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton"; // Import MDButton
import Icon from "@mui/material/Icon"; // Import Icon
import backgroundImage from "assets/images/bg-profile.jpeg";
import axios from "axios";

function Header({ children }) {
  const [username, setUsername] = useState("username");
  const [email, setEmail] = useState("email");
  const navigate = useNavigate();


  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem("access_token");
      if (token) {
        try {
          const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/get-admin-detail`, {
            token: token // Pass the token in the request body
          });

          const userData = response.data;
          const userDetail = userData.user;
          setUsername(userDetail.username || "username");
          setEmail(userDetail.email || "email");
        } catch (error) {
          if (error.response.status === 401) {
            console.error('401 Error-------');
            localStorage.clear();
            navigate('/auth/login');
          }
          console.error("Error fetching user data", error);
        }
      }
    };

    fetchUserData();
  }, []);

  return (
    <MDBox position="relative" mb={5}>
      <MDBox
        display="flex"
        alignItems="center"
        position="relative"
        minHeight="18.75rem"
        borderRadius="xl"
        sx={{
          backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.info.main, 0.6),
              rgba(gradients.info.state, 0.6)
            )}, url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "50%",
          overflow: "hidden",
        }}
      />
      <Card
        sx={{
          position: "relative",
          mt: -8,
          mx: 3,
          py: 2,
          px: 2,
        }}
      >
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            {/* <MDAvatar src={burceMars} alt="profile-image" size="xl" shadow="sm" /> */}
          </Grid>
          <Grid item>
            <MDBox height="100%" mt={0.5} lineHeight={1}>
              <MDTypography variant="h5" fontWeight="medium">
                {username}
              </MDTypography>
              <MDTypography variant="button" color="text" fontWeight="regular">
                CEO / Email: {email}
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4} sx={{ ml: "auto" }}>
            <AppBar position="static">
              <Grid container spacing={1} justifyContent="flex-end">
                <Grid item>
                  <MDButton
                    variant="gradient"
                    color="success"
                    fullWidth
                    component={Link}
                    to="/admin-change-password"
                    startIcon={<Icon>lock_open</Icon>} // Add lock_open icon
                    sx={{ marginLeft: "auto" }} // Float the button to the right
                  >
                    Change Password
                  </MDButton>
                </Grid>
              </Grid>
            </AppBar>
          </Grid>
        </Grid>
        {children}
      </Card>
    </MDBox>
  );
}

// Setting default props for the Header
Header.defaultProps = {
  children: "",
};

// Typechecking props for the Header
Header.propTypes = {
  children: PropTypes.node,
};

export default Header;
